import { h } from 'vue';
import defaultPhoto from '../assets/default-user.png'; // Ensure this path is correct

function createCustomToastContent(employee_name, employee_photo_url, message, cssClass = "employee-response-toast") {
  const photoUrl = employee_photo_url || defaultPhoto;
  const truncatedName = employee_name.length > 22 ? `${employee_name.substring(0, 22)}...` : employee_name;

  // Image error handling
  const handleImageError = (event) => {
    event.target.src = defaultPhoto;
  };

  return h('div', { class: cssClass }, [
    h('div', { class: 'toast-photo' }, [
      h('img', { 
        src: photoUrl, 
        alt: 'Employee Photo', 
        onError: handleImageError,
        style: 'width: 66px; height: auto; object-fit: cover;'
      }),
    ]),
    h('div', { class: 'message-box' }, [
      h('strong', { class: 'toast-header' }, truncatedName),
      h('p', { class: 'toast-message' }, message),
    ]),
  ]);
}

export default createCustomToastContent;